export default "__VITE_ASSET__B2pBBtxs__"